import { Link } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { catalogApi } from '@/lib/api';
import { ProductGrid } from '@/components/ProductGrid';
import { Button } from '@/components/ui/button';

const CATEGORIES = [
  { name: 'Wandcraft', slug: 'Wandcraft', blurb: 'Phoenix, unicorn, dragon — find what chooses you.' },
  { name: 'Apothecary', slug: 'Apothecary', blurb: 'Potions, philtres, and a little Felix Felicis.' },
  { name: 'Quidditch', slug: 'Quidditch', blurb: 'Brooms, balls, and the occasional Bludger pair.' },
  { name: 'Familiars', slug: 'Familiars', blurb: 'Owls, toads, kneazles, and one Pygmy Puff.' },
  { name: 'Confectionery', slug: 'Confectionery', blurb: 'Honeydukes\' finest. Mind the Bertie Botts.' },
  { name: 'Books', slug: 'Books & Scrolls', blurb: 'From spell primers to Hogwarts: A History.' },
];

export function Home() {
  const featured = useQuery({
    queryKey: ['featured'],
    queryFn: async () => (await catalogApi.featured()).data,
  });

  return (
    <div className="space-y-12">
      <section
        className="rounded-xl border border-(--color-galleon-gold)/40 bg-(--color-parchment) p-8 sm:p-12 text-center"
      >
        <h1 className="font-display text-4xl sm:text-5xl mb-3">Welcome to Diagon Alley</h1>
        <p className="text-(--color-ink-muted) max-w-xl mx-auto mb-6">
          Wands, potions, brooms, owls — the wizarding-world e-commerce demo for the
          OpenTelemetry workshop. Every click is traced, every order is followed.
        </p>
        <Button asChild variant="cta" size="lg">
          <a href="#featured">Browse featured</a>
        </Button>
      </section>

      <section id="featured" aria-labelledby="featured-heading">
        <h2 id="featured-heading" className="font-display text-2xl mb-4">Featured</h2>
        <ProductGrid products={featured.data} loading={featured.isLoading} emptyMessage="No featured products yet." />
      </section>

      <section aria-labelledby="categories-heading">
        <h2 id="categories-heading" className="font-display text-2xl mb-4">Shop by Category</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {CATEGORIES.map((c) => (
            <Link
              key={c.slug}
              to={`/c/${encodeURIComponent(c.slug)}`}
              className="block rounded-lg border bg-card p-6 hover:border-(--color-spell-violet) transition-colors"
            >
              <h3 className="font-display text-lg mb-1">{c.name}</h3>
              <p className="text-sm text-(--color-ink-muted)">{c.blurb}</p>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
